(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('authority', {
            parent: 'entity',
            url: '/authority',
            data: {
                authorities: ['USER_ADMIN'],
                pageTitle: 'showcaseApp.authority.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/authority/authorities.html',
                    controller: 'AuthorityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('authority');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('authority-detail', {
            parent: 'authority',
            url: '/authority/{id}',
            data: {
                authorities: ['USER_ADMIN'],
                pageTitle: 'showcaseApp.authority.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/authority/authority-detail.html',
                    controller: 'AuthorityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('authority');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Authority', function($stateParams, Authority) {
                    return Authority.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'authority',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('authority-detail.edit', {
            parent: 'authority-detail',
            url: '/detail/edit',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('authority.new', {
            parent: 'authority',
            url: '/new',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('authority');
                });
            }]
        })
        .state('authority.edit', {
            parent: 'authority',
            url: '/{id}/edit',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-dialog.html',
                    controller: 'AuthorityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('authority.delete', {
            parent: 'authority',
            url: '/{id}/delete',
            data: {
                authorities: ['USER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/authority/authority-delete-dialog.html',
                    controller: 'AuthorityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Authority', function(Authority) {
                            return Authority.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('authority', null, { reload: 'authority' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
